import { Handle, Position } from "@xyflow/react";
import { Select, Input } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";

const { Option } = Select;

const TriggerNode = ({ data, selected }) => {
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#6366f1" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 260,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <ThunderboltOutlined style={{ color: "#6366f1", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Trigger</strong>
      </div>

      <div style={{ marginBottom: 8 }}>
        <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Starting Step</label>
        <Select
          value={data.triggerType || "keyword"}
          onChange={(v) => onChange("triggerType", v)}
          size="small"
          style={{ width: "100%" }}
        >
          <Option value="keyword">Text contains keyword</Option>
          <Option value="newContact">New contact first message</Option>
          <Option value="campaignReply">Campaign reply</Option>
          <Option value="manual">Manual trigger</Option>
        </Select>
      </div>

      {(data.triggerType === "keyword" || !data.triggerType) && (
        <>
          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Match</label>
          <Select
            value={data.matchCriteria || "contains"}
            onChange={(v) => onChange("matchCriteria", v)}
            size="small"
            style={{ width: "100%", marginBottom: 8 }}
          >
            <Option value="contains">Contains</Option>
            <Option value="exact">Exact</Option>
          </Select>

          <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Trigger keyword</label>
          <Input
            value={data.keyword || ""}
            onChange={(e) => onChange("keyword", e.target.value)}
            placeholder="e.g. hello"
            size="small"
          />
        </>
      )}

      <Handle type="source" position={Position.Right} style={{ background: "#6366f1" }} />
    </div>
  );
};

export default TriggerNode;
